module.exports = __webpack_public_path__ + "img/act-报名记录.04ade039.png";